// TODO: auto-generate this file
// copied from macro-api generated type
// see: macro-api/cloud-storage/model/src/bin/generate_typescript_types.rs

export const FileTypeMap = {
  docx: {
    extension: 'docx',
    mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    app: 'write',
  },
  pdf: { extension: 'pdf', mime: 'application/pdf', app: 'pdf' },
  md: { extension: 'md', mime: 'text/markdown', app: 'md' },
  canvas: {
    extension: 'canvas',
    mime: 'application/x-macro-canvas',
    app: 'canvas',
  },
  coffee: { extension: 'coffee', mime: 'text/plain', app: 'code' },
  cson: { extension: 'cson', mime: 'text/plain', app: 'code' },
  iced: { extension: 'iced', mime: 'text/plain', app: 'code' },
  c: { extension: 'c', mime: 'text/plain', app: 'code' },
  i: { extension: 'i', mime: 'text/plain', app: 'code' },
  cpp: { extension: 'cpp', mime: 'text/plain', app: 'code' },
  cppm: { extension: 'cppm', mime: 'text/plain', app: 'code' },
  cc: { extension: 'cc', mime: 'text/plain', app: 'code' },
  ccm: { extension: 'ccm', mime: 'text/plain', app: 'code' },
  cxx: { extension: 'cxx', mime: 'text/plain', app: 'code' },
  cxxm: { extension: 'cxxm', mime: 'text/plain', app: 'code' },
  cplusplus: { extension: 'c++', mime: 'text/plain', app: 'code' },
  cplusplusm: { extension: 'c++m', mime: 'text/plain', app: 'code' },
  hpp: { extension: 'hpp', mime: 'text/plain', app: 'code' },
  hh: { extension: 'hh', mime: 'text/plain', app: 'code' },
  hxx: { extension: 'hxx', mime: 'text/plain', app: 'code' },
  hplusplus: { extension: 'h++', mime: 'text/plain', app: 'code' },
  h: { extension: 'h', mime: 'text/plain', app: 'code' },
  ii: { extension: 'ii', mime: 'text/plain', app: 'code' },
  ino: { extension: 'ino', mime: 'text/plain', app: 'code' },
  inl: { extension: 'inl', mime: 'text/plain', app: 'code' },
  ipp: { extension: 'ipp', mime: 'text/plain', app: 'code' },
  ixx: { extension: 'ixx', mime: 'text/plain', app: 'code' },
  tpp: { extension: 'tpp', mime: 'text/plain', app: 'code' },
  txx: { extension: 'txx', mime: 'text/plain', app: 'code' },
  hppin: { extension: 'hpp.in', mime: 'text/plain', app: 'code' },
  hin: { extension: 'h.in', mime: 'text/plain', app: 'code' },
  cu: { extension: 'cu', mime: 'text/plain', app: 'code' },
  cuh: { extension: 'cuh', mime: 'text/plain', app: 'code' },
  cs: { extension: 'cs', mime: 'text/plain', app: 'code' },
  csx: { extension: 'csx', mime: 'text/plain', app: 'code' },
  cake: { extension: 'cake', mime: 'text/plain', app: 'code' },
  css: { extension: 'css', mime: 'text/plain', app: 'code' },
  dart: { extension: 'dart', mime: 'text/plain', app: 'code' },
  diff: { extension: 'diff', mime: 'text/plain', app: 'code' },
  patch: { extension: 'patch', mime: 'text/plain', app: 'code' },
  rej: { extension: 'rej', mime: 'text/plain', app: 'code' },
  dockerfile: { extension: 'dockerfile', mime: 'text/plain', app: 'code' },
  containerfile: {
    extension: 'containerfile',
    mime: 'text/plain',
    app: 'code',
  },
  go: { extension: 'go', mime: 'text/plain', app: 'code' },
  handlebars: { extension: 'handlebars', mime: 'text/plain', app: 'code' },
  hbs: { extension: 'hbs', mime: 'text/plain', app: 'code' },
  hjs: { extension: 'hjs', mime: 'text/plain', app: 'code' },
  hlsl: { extension: 'hlsl', mime: 'text/plain', app: 'code' },
  hlsli: { extension: 'hlsli', mime: 'text/plain', app: 'code' },
  fx: { extension: 'fx', mime: 'text/plain', app: 'code' },
  fxh: { extension: 'fxh', mime: 'text/plain', app: 'code' },
  vsh: { extension: 'vsh', mime: 'text/plain', app: 'code' },
  psh: { extension: 'psh', mime: 'text/plain', app: 'code' },
  cginc: { extension: 'cginc', mime: 'text/plain', app: 'code' },
  compute: { extension: 'compute', mime: 'text/plain', app: 'code' },
  html: { extension: 'html', mime: 'text/plain', app: 'code' },
  htm: { extension: 'htm', mime: 'text/plain', app: 'code' },
  shtml: { extension: 'shtml', mime: 'text/plain', app: 'code' },
  xhtml: { extension: 'xhtml', mime: 'text/plain', app: 'code' },
  xht: { extension: 'xht', mime: 'text/plain', app: 'code' },
  mdoc: { extension: 'mdoc', mime: 'text/plain', app: 'code' },
  jsp: { extension: 'jsp', mime: 'text/plain', app: 'code' },
  asp: { extension: 'asp', mime: 'text/plain', app: 'code' },
  aspx: { extension: 'aspx', mime: 'text/plain', app: 'code' },
  jshtm: { extension: 'jshtm', mime: 'text/plain', app: 'code' },
  volt: { extension: 'volt', mime: 'text/plain', app: 'code' },
  ejs: { extension: 'ejs', mime: 'text/plain', app: 'code' },
  rhtml: { extension: 'rhtml', mime: 'text/plain', app: 'code' },
  ini: { extension: 'ini', mime: 'text/plain', app: 'code' },
  conf: { extension: 'conf', mime: 'text/plain', app: 'code' },
  properties: { extension: 'properties', mime: 'text/plain', app: 'code' },
  cfg: { extension: 'cfg', mime: 'text/plain', app: 'code' },
  directory: { extension: 'directory', mime: 'text/plain', app: 'code' },
  gitattributes: {
    extension: 'gitattributes',
    mime: 'text/plain',
    app: 'code',
  },
  gitconfig: { extension: 'gitconfig', mime: 'text/plain', app: 'code' },
  gitmodules: { extension: 'gitmodules', mime: 'text/plain', app: 'code' },
  editorconfig: { extension: 'editorconfig', mime: 'text/plain', app: 'code' },
  repo: { extension: 'repo', mime: 'text/plain', app: 'code' },
  java: { extension: 'java', mime: 'text/plain', app: 'code' },
  jav: { extension: 'jav', mime: 'text/plain', app: 'code' },
  jsx: { extension: 'jsx', mime: 'text/plain', app: 'code' },
  js: { extension: 'js', mime: 'text/plain', app: 'code' },
  es6: { extension: 'es6', mime: 'text/plain', app: 'code' },
  mjs: { extension: 'mjs', mime: 'text/plain', app: 'code' },
  cjs: { extension: 'cjs', mime: 'text/plain', app: 'code' },
  pac: { extension: 'pac', mime: 'text/plain', app: 'code' },
  json: { extension: 'json', mime: 'text/plain', app: 'code' },
  bowerrc: { extension: 'bowerrc', mime: 'text/plain', app: 'code' },
  jscsrc: { extension: 'jscsrc', mime: 'text/plain', app: 'code' },
  webmanifest: { extension: 'webmanifest', mime: 'text/plain', app: 'code' },
  jsmap: { extension: 'js.map', mime: 'text/plain', app: 'code' },
  cssmap: { extension: 'css.map', mime: 'text/plain', app: 'code' },
  tsmap: { extension: 'ts.map', mime: 'text/plain', app: 'code' },
  har: { extension: 'har', mime: 'text/plain', app: 'code' },
  jslintrc: { extension: 'jslintrc', mime: 'text/plain', app: 'code' },
  jsonld: { extension: 'jsonld', mime: 'text/plain', app: 'code' },
  geojson: { extension: 'geojson', mime: 'text/plain', app: 'code' },
  ipynb: { extension: 'ipynb', mime: 'text/plain', app: 'code' },
  vuerc: { extension: 'vuerc', mime: 'text/plain', app: 'code' },
  jsonc: { extension: 'jsonc', mime: 'text/plain', app: 'code' },
  eslintrc: { extension: 'eslintrc', mime: 'text/plain', app: 'code' },
  eslintrcjson: { extension: 'eslintrc.json', mime: 'text/plain', app: 'code' },
  jsfmtrc: { extension: 'jsfmtrc', mime: 'text/plain', app: 'code' },
  jshintrc: { extension: 'jshintrc', mime: 'text/plain', app: 'code' },
  swcrc: { extension: 'swcrc', mime: 'text/plain', app: 'code' },
  hintrc: { extension: 'hintrc', mime: 'text/plain', app: 'code' },
  babelrc: { extension: 'babelrc', mime: 'text/plain', app: 'code' },
  jsonl: { extension: 'jsonl', mime: 'text/plain', app: 'code' },
  ndjson: { extension: 'ndjson', mime: 'text/plain', app: 'code' },
  codesnippets: { extension: 'code-snippets', mime: 'text/plain', app: 'code' },
  jl: { extension: 'jl', mime: 'text/plain', app: 'code' },
  jmd: { extension: 'jmd', mime: 'text/plain', app: 'code' },
  sty: { extension: 'sty', mime: 'text/plain', app: 'code' },
  cls: { extension: 'cls', mime: 'text/plain', app: 'code' },
  bbx: { extension: 'bbx', mime: 'text/plain', app: 'code' },
  cbx: { extension: 'cbx', mime: 'text/plain', app: 'code' },
  tex: { extension: 'tex', mime: 'text/plain', app: 'code' },
  ltx: { extension: 'ltx', mime: 'text/plain', app: 'code' },
  ctx: { extension: 'ctx', mime: 'text/plain', app: 'code' },
  bib: { extension: 'bib', mime: 'text/plain', app: 'code' },
  less: { extension: 'less', mime: 'text/plain', app: 'code' },
  log: { extension: 'log', mime: 'text/plain', app: 'code' },
  lua: { extension: 'lua', mime: 'text/plain', app: 'code' },
  mak: { extension: 'mak', mime: 'text/plain', app: 'code' },
  mk: { extension: 'mk', mime: 'text/plain', app: 'code' },
  mkd: { extension: 'mkd', mime: 'text/plain', app: 'code' },
  mdwn: { extension: 'mdwn', mime: 'text/plain', app: 'code' },
  mdown: { extension: 'mdown', mime: 'text/plain', app: 'code' },
  markdown: { extension: 'markdown', mime: 'text/plain', app: 'code' },
  markdn: { extension: 'markdn', mime: 'text/plain', app: 'code' },
  mdtxt: { extension: 'mdtxt', mime: 'text/plain', app: 'code' },
  mdtext: { extension: 'mdtext', mime: 'text/plain', app: 'code' },
  workbook: { extension: 'workbook', mime: 'text/plain', app: 'code' },
  m: { extension: 'm', mime: 'text/plain', app: 'code' },
  mm: { extension: 'mm', mime: 'text/plain', app: 'code' },
  pl: { extension: 'pl', mime: 'text/plain', app: 'code' },
  pm: { extension: 'pm', mime: 'text/plain', app: 'code' },
  pod: { extension: 'pod', mime: 'text/plain', app: 'code' },
  t: { extension: 't', mime: 'text/plain', app: 'code' },
  psgi: { extension: 'psgi', mime: 'text/plain', app: 'code' },
  raku: { extension: 'raku', mime: 'text/plain', app: 'code' },
  rakumod: { extension: 'rakumod', mime: 'text/plain', app: 'code' },
  rakutest: { extension: 'rakutest', mime: 'text/plain', app: 'code' },
  rakudoc: { extension: 'rakudoc', mime: 'text/plain', app: 'code' },
  nqp: { extension: 'nqp', mime: 'text/plain', app: 'code' },
  p6: { extension: 'p6', mime: 'text/plain', app: 'code' },
  pl6: { extension: 'pl6', mime: 'text/plain', app: 'code' },
  pm6: { extension: 'pm6', mime: 'text/plain', app: 'code' },
  php: { extension: 'php', mime: 'text/plain', app: 'code' },
  php4: { extension: 'php4', mime: 'text/plain', app: 'code' },
  php5: { extension: 'php5', mime: 'text/plain', app: 'code' },
  phtml: { extension: 'phtml', mime: 'text/plain', app: 'code' },
  ctp: { extension: 'ctp', mime: 'text/plain', app: 'code' },
  ps1: { extension: 'ps1', mime: 'text/plain', app: 'code' },
  psm1: { extension: 'psm1', mime: 'text/plain', app: 'code' },
  psd1: { extension: 'psd1', mime: 'text/plain', app: 'code' },
  pssc: { extension: 'pssc', mime: 'text/plain', app: 'code' },
  psrc: { extension: 'psrc', mime: 'text/plain', app: 'code' },
  py: { extension: 'py', mime: 'text/plain', app: 'code' },
  rpy: { extension: 'rpy', mime: 'text/plain', app: 'code' },
  pyw: { extension: 'pyw', mime: 'text/plain', app: 'code' },
  cpy: { extension: 'cpy', mime: 'text/plain', app: 'code' },
  gyp: { extension: 'gyp', mime: 'text/plain', app: 'code' },
  gypi: { extension: 'gypi', mime: 'text/plain', app: 'code' },
  pyi: { extension: 'pyi', mime: 'text/plain', app: 'code' },
  ipy: { extension: 'ipy', mime: 'text/plain', app: 'code' },
  pyt: { extension: 'pyt', mime: 'text/plain', app: 'code' },
  r: { extension: 'r', mime: 'text/plain', app: 'code' },
  rhistory: { extension: 'rhistory', mime: 'text/plain', app: 'code' },
  rprofile: { extension: 'rprofile', mime: 'text/plain', app: 'code' },
  rt: { extension: 'rt', mime: 'text/plain', app: 'code' },
  cshtml: { extension: 'cshtml', mime: 'text/plain', app: 'code' },
  razor: { extension: 'razor', mime: 'text/plain', app: 'code' },
  rb: { extension: 'rb', mime: 'text/plain', app: 'code' },
  rbx: { extension: 'rbx', mime: 'text/plain', app: 'code' },
  rjs: { extension: 'rjs', mime: 'text/plain', app: 'code' },
  gemspec: { extension: 'gemspec', mime: 'text/plain', app: 'code' },
  rake: { extension: 'rake', mime: 'text/plain', app: 'code' },
  ru: { extension: 'ru', mime: 'text/plain', app: 'code' },
  erb: { extension: 'erb', mime: 'text/plain', app: 'code' },
  podspec: { extension: 'podspec', mime: 'text/plain', app: 'code' },
  rbi: { extension: 'rbi', mime: 'text/plain', app: 'code' },
  rs: { extension: 'rs', mime: 'text/plain', app: 'code' },
  scss: { extension: 'scss', mime: 'text/plain', app: 'code' },
  sass: { extension: 'sass', mime: 'text/plain', app: 'code' },
  shader: { extension: 'shader', mime: 'text/plain', app: 'code' },
  sh: { extension: 'sh', mime: 'text/plain', app: 'code' },
  bash: { extension: 'bash', mime: 'text/plain', app: 'code' },
  bashrc: { extension: 'bashrc', mime: 'text/plain', app: 'code' },
  bashaliases: { extension: 'bash_aliases', mime: 'text/plain', app: 'code' },
  bashprofile: { extension: 'bash_profile', mime: 'text/plain', app: 'code' },
  bashlogin: { extension: 'bash_login', mime: 'text/plain', app: 'code' },
  ebuild: { extension: 'ebuild', mime: 'text/plain', app: 'code' },
  eclass: { extension: 'eclass', mime: 'text/plain', app: 'code' },
  profile: { extension: 'profile', mime: 'text/plain', app: 'code' },
  bashlogout: { extension: 'bash_logout', mime: 'text/plain', app: 'code' },
  xprofile: { extension: 'xprofile', mime: 'text/plain', app: 'code' },
  xsession: { extension: 'xsession', mime: 'text/plain', app: 'code' },
  xsessionrc: { extension: 'xsessionrc', mime: 'text/plain', app: 'code' },
  zsh: { extension: 'zsh', mime: 'text/plain', app: 'code' },
  zshrc: { extension: 'zshrc', mime: 'text/plain', app: 'code' },
  zprofile: { extension: 'zprofile', mime: 'text/plain', app: 'code' },
  zlogin: { extension: 'zlogin', mime: 'text/plain', app: 'code' },
  zlogout: { extension: 'zlogout', mime: 'text/plain', app: 'code' },
  zshenv: { extension: 'zshenv', mime: 'text/plain', app: 'code' },
  zshtheme: { extension: 'zsh-theme', mime: 'text/plain', app: 'code' },
  fish: { extension: 'fish', mime: 'text/plain', app: 'code' },
  ksh: { extension: 'ksh', mime: 'text/plain', app: 'code' },
  csh: { extension: 'csh', mime: 'text/plain', app: 'code' },
  cshrc: { extension: 'cshrc', mime: 'text/plain', app: 'code' },
  tcshrc: { extension: 'tcshrc', mime: 'text/plain', app: 'code' },
  yashrc: { extension: 'yashrc', mime: 'text/plain', app: 'code' },
  yashprofile: { extension: 'yash_profile', mime: 'text/plain', app: 'code' },
  sql: { extension: 'sql', mime: 'text/plain', app: 'code' },
  dsql: { extension: 'dsql', mime: 'text/plain', app: 'code' },
  swift: { extension: 'swift', mime: 'text/plain', app: 'code' },
  ts: { extension: 'ts', mime: 'text/plain', app: 'code' },
  cts: { extension: 'cts', mime: 'text/plain', app: 'code' },
  mts: { extension: 'mts', mime: 'text/plain', app: 'code' },
  tsx: { extension: 'tsx', mime: 'text/plain', app: 'code' },
  tsbuildinfo: { extension: 'tsbuildinfo', mime: 'text/plain', app: 'code' },
  xml: { extension: 'xml', mime: 'text/plain', app: 'code' },
  xsd: { extension: 'xsd', mime: 'text/plain', app: 'code' },
  ascx: { extension: 'ascx', mime: 'text/plain', app: 'code' },
  atom: { extension: 'atom', mime: 'text/plain', app: 'code' },
  axml: { extension: 'axml', mime: 'text/plain', app: 'code' },
  axaml: { extension: 'axaml', mime: 'text/plain', app: 'code' },
  bpmn: { extension: 'bpmn', mime: 'text/plain', app: 'code' },
  cpt: { extension: 'cpt', mime: 'text/plain', app: 'code' },
  csl: { extension: 'csl', mime: 'text/plain', app: 'code' },
  csproj: { extension: 'csproj', mime: 'text/plain', app: 'code' },
  csprojuser: { extension: 'csproj.user', mime: 'text/plain', app: 'code' },
  dita: { extension: 'dita', mime: 'text/plain', app: 'code' },
  ditamap: { extension: 'ditamap', mime: 'text/plain', app: 'code' },
  dtd: { extension: 'dtd', mime: 'text/plain', app: 'code' },
  ent: { extension: 'ent', mime: 'text/plain', app: 'code' },
  mod: { extension: 'mod', mime: 'text/plain', app: 'code' },
  dtml: { extension: 'dtml', mime: 'text/plain', app: 'code' },
  fsproj: { extension: 'fsproj', mime: 'text/plain', app: 'code' },
  fxml: { extension: 'fxml', mime: 'text/plain', app: 'code' },
  iml: { extension: 'iml', mime: 'text/plain', app: 'code' },
  isml: { extension: 'isml', mime: 'text/plain', app: 'code' },
  jmx: { extension: 'jmx', mime: 'text/plain', app: 'code' },
  launch: { extension: 'launch', mime: 'text/plain', app: 'code' },
  menu: { extension: 'menu', mime: 'text/plain', app: 'code' },
  mxml: { extension: 'mxml', mime: 'text/plain', app: 'code' },
  nuspec: { extension: 'nuspec', mime: 'text/plain', app: 'code' },
  opml: { extension: 'opml', mime: 'text/plain', app: 'code' },
  owl: { extension: 'owl', mime: 'text/plain', app: 'code' },
  proj: { extension: 'proj', mime: 'text/plain', app: 'code' },
  props: { extension: 'props', mime: 'text/plain', app: 'code' },
  pt: { extension: 'pt', mime: 'text/plain', app: 'code' },
  publishsettings: {
    extension: 'publishsettings',
    mime: 'text/plain',
    app: 'code',
  },
  pubxml: { extension: 'pubxml', mime: 'text/plain', app: 'code' },
  pubxmluser: { extension: 'pubxml.user', mime: 'text/plain', app: 'code' },
  rbxlx: { extension: 'rbxlx', mime: 'text/plain', app: 'code' },
  rbxmx: { extension: 'rbxmx', mime: 'text/plain', app: 'code' },
  rdf: { extension: 'rdf', mime: 'text/plain', app: 'code' },
  rng: { extension: 'rng', mime: 'text/plain', app: 'code' },
  rss: { extension: 'rss', mime: 'text/plain', app: 'code' },
  shproj: { extension: 'shproj', mime: 'text/plain', app: 'code' },
  storyboard: { extension: 'storyboard', mime: 'text/plain', app: 'code' },
  targets: { extension: 'targets', mime: 'text/plain', app: 'code' },
  tld: { extension: 'tld', mime: 'text/plain', app: 'code' },
  tmx: { extension: 'tmx', mime: 'text/plain', app: 'code' },
  vbproj: { extension: 'vbproj', mime: 'text/plain', app: 'code' },
  vbprojuser: { extension: 'vbproj.user', mime: 'text/plain', app: 'code' },
  vcxproj: { extension: 'vcxproj', mime: 'text/plain', app: 'code' },
  vcxprojfilters: {
    extension: 'vcxproj.filters',
    mime: 'text/plain',
    app: 'code',
  },
  wsdl: { extension: 'wsdl', mime: 'text/plain', app: 'code' },
  wxi: { extension: 'wxi', mime: 'text/plain', app: 'code' },
  wxl: { extension: 'wxl', mime: 'text/plain', app: 'code' },
  wxs: { extension: 'wxs', mime: 'text/plain', app: 'code' },
  xaml: { extension: 'xaml', mime: 'text/plain', app: 'code' },
  xbl: { extension: 'xbl', mime: 'text/plain', app: 'code' },
  xib: { extension: 'xib', mime: 'text/plain', app: 'code' },
  xlf: { extension: 'xlf', mime: 'text/plain', app: 'code' },
  xliff: { extension: 'xliff', mime: 'text/plain', app: 'code' },
  xpdl: { extension: 'xpdl', mime: 'text/plain', app: 'code' },
  xul: { extension: 'xul', mime: 'text/plain', app: 'code' },
  xoml: { extension: 'xoml', mime: 'text/plain', app: 'code' },
  xsl: { extension: 'xsl', mime: 'text/plain', app: 'code' },
  xslt: { extension: 'xslt', mime: 'text/plain', app: 'code' },
  yaml: { extension: 'yaml', mime: 'text/plain', app: 'code' },
  yml: { extension: 'yml', mime: 'text/plain', app: 'code' },
  eyaml: { extension: 'eyaml', mime: 'text/plain', app: 'code' },
  eyml: { extension: 'eyml', mime: 'text/plain', app: 'code' },
  cff: { extension: 'cff', mime: 'text/plain', app: 'code' },
  yamltmlanguage: {
    extension: 'yaml-tmlanguage',
    mime: 'text/plain',
    app: 'code',
  },
  yamltmpreferences: {
    extension: 'yaml-tmpreferences',
    mime: 'text/plain',
    app: 'code',
  },
  yamltmtheme: { extension: 'yaml-tmtheme', mime: 'text/plain', app: 'code' },
  winget: { extension: 'winget', mime: 'text/plain', app: 'code' },
  txt: { extension: 'txt', mime: 'text/plain', app: 'code' },
  csv: { extension: 'csv', mime: 'text/plain', app: 'code' },
  tsv: { extension: 'tsv', mime: 'text/plain', app: 'code' },
  jpeg: { extension: 'jpeg', mime: 'image/jpeg', app: 'image' },
  jpg: { extension: 'jpg', mime: 'image/jpeg', app: 'image' },
  png: { extension: 'png', mime: 'image/png', app: 'image' },
  gif: { extension: 'gif', mime: 'image/gif', app: 'image' },
  svg: { extension: 'svg', mime: 'image/svg+xml', app: 'image' },
  webp: { extension: 'webp', mime: 'image/webp', app: 'image' },
  avif: { extension: 'avif', mime: 'image/avif', app: 'image' },
  bmp: { extension: 'bmp', mime: 'image/bmp', app: 'image' },
  ico: { extension: 'ico', mime: 'image/x-icon', app: 'image' },
  tiff: { extension: 'tiff', mime: 'image/tiff', app: 'image' },
  tif: { extension: 'tif', mime: 'image/tiff', app: 'image' },
  heic: { extension: 'heic', mime: 'image/heic', app: 'image' },
  heif: { extension: 'heif', mime: 'image/heif', app: 'image' },
  tar: { extension: 'tar', mime: 'application/x-tar', app: 'archive' },
  targz: { extension: 'tar.gz', mime: 'application/gzip', app: 'archive' },
  tgz: { extension: 'tgz', mime: 'application/gzip', app: 'archive' },
  gz: { extension: 'gz', mime: 'application/gzip', app: 'archive' },
  bz2: { extension: 'bz2', mime: 'application/x-bzip2', app: 'archive' },
  tarbz2: { extension: 'tar.bz2', mime: 'application/x-bzip2', app: 'archive' },
  tbz2: { extension: 'tbz2', mime: 'application/x-bzip2', app: 'archive' },
  z: { extension: 'z', mime: 'application/x-compress', app: 'archive' },
  tarz: { extension: 'tar.z', mime: 'application/x-compress', app: 'archive' },
  lz: { extension: 'lz', mime: 'application/x-lzip', app: 'archive' },
  tarlz: { extension: 'tar.lz', mime: 'application/x-lzip', app: 'archive' },
  xz: { extension: 'xz', mime: 'application/x-xz', app: 'archive' },
  tarxz: { extension: 'tar.xz', mime: 'application/x-xz', app: 'archive' },
  txz: { extension: 'txz', mime: 'application/x-xz', app: 'archive' },
  lzma: { extension: 'lzma', mime: 'application/x-lzma', app: 'archive' },
  tarlzma: {
    extension: 'tar.lzma',
    mime: 'application/x-lzma',
    app: 'archive',
  },
  rar: { extension: 'rar', mime: 'application/vnd.rar', app: 'archive' },
  sevenz: {
    extension: '7z',
    mime: 'application/x-7z-compressed',
    app: 'archive',
  },
  zst: { extension: 'zst', mime: 'application/zstd', app: 'archive' },
  tarzst: { extension: 'tar.zst', mime: 'application/zstd', app: 'archive' },
  tzst: { extension: 'tzst', mime: 'application/zstd', app: 'archive' },
  zip: { extension: 'zip', mime: 'application/zip', app: 'archive' },
  exe: {
    extension: 'exe',
    mime: 'application/x-msdownload',
    app: 'executable',
  },
  msi: { extension: 'msi', mime: 'application/x-msi', app: 'executable' },
  dll: {
    extension: 'dll',
    mime: 'application/x-msdownload',
    app: 'executable',
  },
  bat: { extension: 'bat', mime: 'application/x-bat', app: 'executable' },
  cmd: { extension: 'cmd', mime: 'application/x-cmd', app: 'executable' },
  com: {
    extension: 'com',
    mime: 'application/x-msdownload',
    app: 'executable',
  },
  appimage: {
    extension: 'appimage',
    mime: 'application/x-executable',
    app: 'executable',
  },
  app: {
    extension: 'app',
    mime: 'application/x-executable',
    app: 'executable',
  },
  bin: {
    extension: 'bin',
    mime: 'application/octet-stream',
    app: 'executable',
  },
  deb: {
    extension: 'deb',
    mime: 'application/vnd.debian.binary-package',
    app: 'executable',
  },
  rpm: { extension: 'rpm', mime: 'application/x-rpm', app: 'executable' },
  apk: {
    extension: 'apk',
    mime: 'application/vnd.android.package-archive',
    app: 'executable',
  },
  dmg: {
    extension: 'dmg',
    mime: 'application/x-apple-diskimage',
    app: 'executable',
  },
  pkg: {
    extension: 'pkg',
    mime: 'application/vnd.apple.installer+xml',
    app: 'executable',
  },
  crx: {
    extension: 'crx',
    mime: 'application/x-chrome-extension',
    app: 'executable',
  },
  xpi: { extension: 'xpi', mime: 'application/x-xpinstall', app: 'executable' },
  mp3: { extension: 'mp3', mime: 'audio/mpeg', app: 'audio' },
  wav: { extension: 'wav', mime: 'audio/wav', app: 'audio' },
  ogg: { extension: 'ogg', mime: 'audio/ogg', app: 'audio' },
  flac: { extension: 'flac', mime: 'audio/flac', app: 'audio' },
  aac: { extension: 'aac', mime: 'audio/aac', app: 'audio' },
  m4a: { extension: 'm4a', mime: 'audio/mp4', app: 'audio' },
  wma: { extension: 'wma', mime: 'audio/x-ms-wma', app: 'audio' },
  mid: { extension: 'mid', mime: 'audio/midi', app: 'audio' },
  midi: { extension: 'midi', mime: 'audio/midi', app: 'audio' },
  mp4: { extension: 'mp4', mime: 'video/mp4', app: 'video' },
  mkv: { extension: 'mkv', mime: 'video/x-matroska', app: 'video' },
  webm: { extension: 'webm', mime: 'video/webm', app: 'video' },
  avi: { extension: 'avi', mime: 'video/x-msvideo', app: 'video' },
  mov: { extension: 'mov', mime: 'video/quicktime', app: 'video' },
  wmv: { extension: 'wmv', mime: 'video/x-ms-wmv', app: 'video' },
  mpg: { extension: 'mpg', mime: 'video/mpeg', app: 'video' },
  mpeg: { extension: 'mpeg', mime: 'video/mpeg', app: 'video' },
  m4v: { extension: 'm4v', mime: 'video/mp4', app: 'video' },
  flv: { extension: 'flv', mime: 'video/x-flv', app: 'video' },
  f4v: { extension: 'f4v', mime: 'video/mp4', app: 'video' },
  threegp: { extension: '3gp', mime: 'video/3gpp', app: 'video' },
  ttf: { extension: 'ttf', mime: 'font/ttf', app: 'font' },
  otf: { extension: 'otf', mime: 'font/otf', app: 'font' },
  woff: { extension: 'woff', mime: 'font/woff', app: 'font' },
  woff2: { extension: 'woff2', mime: 'font/woff2', app: 'font' },
  eot: { extension: 'eot', mime: 'application/vnd.ms-fontobject', app: 'font' },
  rtf: { extension: 'rtf', mime: 'application/rtf', app: 'document' },
  odt: {
    extension: 'odt',
    mime: 'application/vnd.oasis.opendocument.text',
    app: 'document',
  },
  ods: {
    extension: 'ods',
    mime: 'application/vnd.oasis.opendocument.spreadsheet',
    app: 'document',
  },
  odp: {
    extension: 'odp',
    mime: 'application/vnd.oasis.opendocument.presentation',
    app: 'document',
  },
  odg: {
    extension: 'odg',
    mime: 'application/vnd.oasis.opendocument.graphics',
    app: 'document',
  },
  odf: {
    extension: 'odf',
    mime: 'application/vnd.oasis.opendocument.formula',
    app: 'document',
  },
  epub: { extension: 'epub', mime: 'application/epub+zip', app: 'document' },
  mobi: {
    extension: 'mobi',
    mime: 'application/x-mobipocket-ebook',
    app: 'document',
  },
  azw: {
    extension: 'azw',
    mime: 'application/vnd.amazon.ebook',
    app: 'document',
  },
  azw3: {
    extension: 'azw3',
    mime: 'application/vnd.amazon.ebook',
    app: 'document',
  },
  djvu: { extension: 'djvu', mime: 'image/vnd.djvu', app: 'document' },
  xls: { extension: 'xls', mime: 'application/vnd.ms-excel', app: 'document' },
  ppt: {
    extension: 'ppt',
    mime: 'application/vnd.ms-powerpoint',
    app: 'document',
  },
  pptx: { extension: 'pptx', mime: 'application/xml', app: 'document' },
  xlsx: { extension: 'xlsx', mime: 'application/xml', app: 'document' },
  db: { extension: 'db', mime: 'application/octet-stream', app: 'database' },
  sqlite: {
    extension: 'sqlite',
    mime: 'application/vnd.sqlite3',
    app: 'database',
  },
  sqlite3: {
    extension: 'sqlite3',
    mime: 'application/vnd.sqlite3',
    app: 'database',
  },
  mdb: { extension: 'mdb', mime: 'application/vnd.ms-access', app: 'database' },
  accdb: {
    extension: 'accdb',
    mime: 'application/vnd.ms-access',
    app: 'database',
  },
  dbf: { extension: 'dbf', mime: 'application/x-dbf', app: 'database' },
  plist: { extension: 'plist', mime: 'application/xml', app: 'data' },
  toml: { extension: 'toml', mime: 'application/toml', app: 'data' },
  env: { extension: 'env', mime: 'text/plain', app: 'data' },
  dot: { extension: 'dot', mime: 'text/vnd.graphviz', app: 'data' },
  gv: { extension: 'gv', mime: 'text/vnd.graphviz', app: 'data' },
  torrent: {
    extension: 'torrent',
    mime: 'application/x-bittorrent',
    app: 'data',
  },
  ics: { extension: 'ics', mime: 'text/calendar', app: 'data' },
  vcf: { extension: 'vcf', mime: 'text/vcard', app: 'data' },
  ai: { extension: 'ai', mime: 'application/postscript', app: 'vector' },
  eps: { extension: 'eps', mime: 'application/postscript', app: 'vector' },
  ps: { extension: 'ps', mime: 'application/postscript', app: 'vector' },
  dxf: { extension: 'dxf', mime: 'image/vnd.dxf', app: 'vector' },
  dwg: { extension: 'dwg', mime: 'image/vnd.dwg', app: 'vector' },
  stl: { extension: 'stl', mime: 'model/stl', app: '3d' },
  obj: { extension: 'obj', mime: 'model/obj', app: '3d' },
  fbx: { extension: 'fbx', mime: 'application/octet-stream', app: '3d' },
  blend: { extension: 'blend', mime: 'application/x-blender', app: '3d' },
  dae: { extension: 'dae', mime: 'model/vnd.collada+xml', app: '3d' },
  threeds: { extension: '3ds', mime: 'application/x-3ds', app: '3d' },
  gltf: { extension: 'gltf', mime: 'model/gltf+json', app: '3d' },
  glb: { extension: 'glb', mime: 'model/gltf-binary', app: '3d' },
  vhd: { extension: 'vhd', mime: 'application/x-virtualbox-vhd', app: 'vm' },
  vhdx: { extension: 'vhdx', mime: 'application/x-virtualbox-vhdx', app: 'vm' },
  vmdk: { extension: 'vmdk', mime: 'application/x-vmdk', app: 'vm' },
  ova: { extension: 'ova', mime: 'application/x-virtualbox-ova', app: 'vm' },
  ovf: { extension: 'ovf', mime: 'application/x-virtualbox-ovf', app: 'vm' },
  iso: { extension: 'iso', mime: 'application/x-iso9660-image', app: 'vm' },
  img: { extension: 'img', mime: 'application/octet-stream', app: 'vm' },
  swf: {
    extension: 'swf',
    mime: 'application/x-shockwave-flash',
    app: 'media',
  },
} as const;
